import { render, staticRenderFns } from "./Nei.vue?vue&type=template&id=3077c10c&scoped=true&"
import script from "./Nei.vue?vue&type=script&lang=js&"
export * from "./Nei.vue?vue&type=script&lang=js&"
import style0 from "./Nei.vue?vue&type=style&index=0&id=3077c10c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3077c10c",
  null
  
)

export default component.exports